import styles from './bids.module.css';
import LazyImage from "components/LazyImage";
import Link from "next/link";
import globalStyles from "../search.module.css";

type Props = {
    bids: Bids[]
}

type Bids = {
    image: object,
    id: number,
    title: string,
    intro: {
        text: string
    },
    uri: string
}

const Bid = ({ bids }: Props) => {

    const getThumbnail = (rawImages) => {
        const image = {
            origin: "internal",
            src: `${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${rawImages?.format.original.uri}`,
            alt: rawImages?.title || "",
            layout: "fill",
            objectFit: "cover",
            sources: [
                {
                    srcSet: "",
                    type: "image/webp",
                },
                {
                    srcSet: "",
                    type: "image/jpg",
                },
            ],
        }
        const sizesJpg = ['w200', 'w400',];
        const sizeswebp = ['w200wp', 'w400wp'];
        for (const key in rawImages?.format) {
            if (rawImages.format.hasOwnProperty(key)) {
                if (sizeswebp.includes(key)) {
                    image.sources[0].srcSet = `${image.sources[0].srcSet} ${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${rawImages.format[key].uri}  ${rawImages.format[key].width}w,`
                }

                if (sizesJpg.includes(key)) {
                    image.sources[1].srcSet = `${image.sources[1].srcSet} ${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${rawImages.format[key].uri}  ${rawImages.format[key].width}w,`
                }
            }
        }
        return image;
    };

    return (
        <li className={styles.bidLayout}>
            {bids.map((bid) => {
                const formatImage = getThumbnail(bid.image)
                return (
                    <div key={`bid-${bid.id}`} className={styles.card}>
                        <div className={styles.imgContainer}> <LazyImage {...formatImage} /> </div>
                        <div className={styles.innerContent}>
                            <h3>{bid.title}</h3>
                            <p>{bid.intro.text}</p>
                        </div>
                        <div className={styles.tray}>
                            <Link href={`/destinations/${bid.uri}`} passHref prefetch={false} >
                                <button className={globalStyles.primaryButton}>View {bid.title}</button>
                            </Link>
                        </div>
                    </div>
                )
            })}
        </li>
    )
}

export default Bid;